import {Component} from "react";
import store, {getStateParams} from '../Store'
import {push, goBack} from 'connected-react-router'

import QueryString from 'query-string'
import {
    getConfig,
    getConfigWithServices,
    setStateParams,
    alignDayParts, resetWizard, clearExistingMeetingsMode, setSessionToken, getSession, getManifest
} from "./Welcome/Actions";
import {Analytics} from "../Common/Analytics";
import {getSafely, isNonEmptyObject, isNonEmptyString, valueOrDefault} from "@tomeravni/easybizy-js-common/common";
import {resolveCustomerToken} from "../Common/Helpers";
import ReactManifest from 'react-manifest';


const ERROR_PATH = 'error';
const SUCCESS_PATH = '/success';
const PAYMENT_PATH = '/payment';
export const PICK_SERVICES_PATH = '/pick-services';

const WELCOME_PAGE = '/welcome';
const kPathMap = [
    {path: '/identify', allowInvalid: true},
    {path: '/validate', allowInvalid: true},
    {path: PICK_SERVICES_PATH, allowInvalid: true},
    {path: '/pick-employee', allowInvalid: true},
    {path: '/pick-time', allowInvalid: true},
    {path: '/results', allowInvalid: true},
    {path: PAYMENT_PATH, allowInvalid: true},
];

export default class ContainerPage extends Component {
    state = {};

    safeSetState = (toMerge, callback) => {
        if (!this.unmounted) {
            this.setState(toMerge, callback);
        }
    };

    safeSetStateDiff = (toMerge, callback) => {
        const toSet = {};
        Object.keys(toMerge).forEach((key) => {
            if (this.state[key] !== toMerge[key]) {
                toSet[key] = toMerge[key];
            }
        })

        if (isNonEmptyObject(toSet)) {
            this.safeSetState(toSet, callback);
        }
    }


    componentDidMount() {
        this.didMount = true;
        setTimeout(() => this.safeSetState({didMount: true}));
        setTimeout(() => this.safeSetState({delayed: true}), 500);
        // Track page loaded with mixpanel.

        Analytics.trackPage(this.props.location.pathname);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.navigatingToPayment) {
            return;
        }

        let storeState = store.getState();
        const currentState = storeState.schedule;
        let awaitingPaymentToken = getSafely(['configWithServices', 'AwaitingPaymentToken'], currentState);
        if (awaitingPaymentToken) {
            const currentRoute = '/' + this.props.location.pathname.split('/').pop();
            if (![PAYMENT_PATH, SUCCESS_PATH].includes(currentRoute)) {
                this.setState({navigatingToPayment: true}, () => {
                    store.dispatch(setSessionToken(awaitingPaymentToken))
                    return this.navigate(PAYMENT_PATH)
                })


            }
        }
    }

    componentWillMount() {
        let storeState = store.getState();
        const currentState = storeState.schedule;

        this._reloadState();

        if (currentState.errorWithConfig) {
            this.humanizeError = this.translateErrorOrFallback(currentState.errorWithConfig, 'schedule.errorLoadingConfig');
        }

        if (currentState.errorWithServices) {
            this.humanizeError = this.translateErrorOrFallback(currentState.errorWithConfig, 'schedule.errorLoadingServices');
        }

        if (storeState.identify.sendingValidationError) {
            this.humanizeError = this.translateErrorOrFallback(currentState.errorWithConfig, storeState.identify.sendingValidationError.message);
        }

        if (storeState.identify.validatingCodeError && storeState.identify.validatingCodeError.statusCode === 403) {
            this.humanizeError = this.translateErrorOrFallback(currentState.errorWithConfig, storeState.identify.validatingCodeError.message);
        }

        const errorId = QueryString.parse(this.props.location.search).error;
        if (errorId) {
            this.humanizeError = this.translateErrorOrFallback(null, errorId);
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        let storeState = store.getState();
        const scheduleState = storeState.schedule;
        if (scheduleState.errorInstantOptions && !this.instantOptionsError) {
            this.instantOptionsError = this.props.intl.formatMessage({id: scheduleState.errorInstantOptions.statusCode === 503 ? 'app.rateLimit' : 'schedule.noInstantOptionsError'});
            setTimeout(() => this.forceUpdate());
        }

        if (scheduleState.errorSpecificOptions && !this.specificOptionsError) {
            this.specificOptionsError = this.props.intl.formatMessage({id: scheduleState.errorSpecificOptions.statusCode === 503 ? 'app.rateLimit' : 'schedule.noSpecificOptionsError'});
            setTimeout(() => this.forceUpdate());
        }

        if (storeState.identify.sendingValidationError
            || (storeState.identify.validatingCodeError && storeState.identify.validatingCodeError.statusCode === 403)) {
            this.fatalError();
        }

        if (nextProps.config) {
            this.updateManifestLink(nextProps.config.Token, nextProps.config.ContextName);
        }
    }

    updateManifestLink(token, contextName) {
        const {manifest, requestingManifest, manifestError} = store.getState().schedule;
        if (isNonEmptyObject(manifest) || requestingManifest || manifestError) {
            return;
        }

        store.dispatch(getManifest(token, contextName, (res) => {
            ReactManifest.update(res, "#manifest-placeholder");
            const message = this.props.intl.formatMessage({id: 'add_to_home_screen_message'});
            window.addToHomescreen({
                debug: true, autostart: false, modal: true, message: {
                    en_us: {
                        ios: message,
                        android: message
                    },
                    he_il: {
                        ios: message,
                        android: message
                    }
                }
            });

        }));
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    clearExistingMeetingsMode() {
        store.dispatch(clearExistingMeetingsMode())
    }

    _reloadState() {
        const {context, customerToken} = this.resolveContextAndCustomer();
        let parsedLocation = QueryString.parse(this.props.location.search);
        const {
            token,
            service_id,
            day_part,
            date,
            mobile,
            email,
            validation_hash,
            employee_id,
            existing_mode,
            quantities,
            gender,
            s_category,
            s_token,
        } = parsedLocation;

        let existingModeObject;
        let existingModeString;

        try {
            existingModeObject = JSON.parse(existing_mode);
            existingModeString = JSON.stringify(existingModeObject);
        } catch (e) {
            /// Couldn't parse === DONT EXIST.
        }

        const currentState = store.getState().schedule;
        let recentToken = (currentState.config && token === currentState.config.ContextOnlyToken && currentState.config.Token) || token;

        if (!s_token) {
            store.dispatch(setStateParams(recentToken, service_id, employee_id, day_part, date, mobile, email, validation_hash, existingModeString, quantities, gender, s_category));
        } else {
            store.dispatch(setSessionToken(s_token))
            store.dispatch(getSession(s_token))
        }


        if (!currentState.config) {
            store.dispatch(getConfig(context, customerToken, (err, config) => {
                if (!err) {
                    Analytics.setDimension('dimension1', config.BusinessName);
                    store.dispatch(getConfigWithServices(context, customerToken, (err, configWithServices) => {
                        if (err) {
                            this.error = true;
                            this.fatalError();
                        }

                        if (!this.allowAnonymous && !configWithServices.Customer) {
                            return this.navigate(Routes.identify)
                        }
                    }));

                    if (config.Customer) {
                        Analytics.identify(config.Token);
                    }
                } else {
                    this.error = true;
                    this.fatalError();
                }
            }));

        }

        if (day_part) {
            store.dispatch(alignDayParts(day_part));
        }
    }

    pickTime() {
        this.navigate(Routes.pickTime);
    }

    next() {
        this.navigate(this.nextRoute);
    }

    navigate(route, optionalCustomerToken = null, ignoreSearch = false) {
        let stateParams = getStateParams();
        let routePrefix = this.getRoutePrefix(optionalCustomerToken);
        if (isNonEmptyString(routePrefix)) {
            delete stateParams.token;
        }

        const search = QueryString.stringify(stateParams);
        store.dispatch(push(
            {
                search: !ignoreSearch ? search : '',
                pathname: `${routePrefix}${route}`
            }
        ));
    }

    getRoutePrefix(optionalCustomerToken = null) {
        const contextName = this.getContextName();
        const token = optionalCustomerToken || this.getCustomerToken();

        let postFix = '';
        if (isNonEmptyString(token)) {
            postFix = `/${token}`;
        }

        return `/${contextName.toLowerCase()}${postFix}`;
    }

    getContextName() {
        return getSafely(['props', 'config', 'ContextName'], this) || getSafely(['props', 'match', 'params', 'context'], this, '');
    }

    getCustomerToken() {
        return resolveCustomerToken(this.props.config) || getSafely(['props', 'match', 'params', 'customer'], this);
    }

    fatalError(errId) {
        const pathname = valueOrDefault(window.location.pathname, '').split('/').pop();
        if (pathname !== ERROR_PATH) {
            const {context, customerToken} = this.resolveContextAndCustomer();
            let finalErrorUrl = `${isNonEmptyString(context) ? `/${context}` : ''}${isNonEmptyString(customerToken) ? `/${customerToken}` : ''}/${ERROR_PATH}`;
            let path = {pathname: finalErrorUrl, search: QueryString.stringify({error: errId})};
            store.dispatch(push(path));
            setTimeout(() => {
                store.dispatch(resetWizard());
            }, 1000);
        }
    }

    showToastMessage(errorMessage) {
        if (this.toast) {
            this.toast.getWrappedInstance().show(errorMessage)
        }
    }

    reset = () => {
        this.startOver();
        store.dispatch(resetWizard());
    }

    goBack() {
        store.dispatch(goBack());
    }

    loadPreviousRoute() {
        let pathIndex;
        for (pathIndex = 0; pathIndex < kPathMap.length; pathIndex++) {
            if (this.props.location.pathname.includes(kPathMap[pathIndex].path)) {
                break;
            }
        }

        const search = QueryString.stringify(getStateParams());
        const routePrefix = this.getRoutePrefix();
        const previousPath = kPathMap[--pathIndex].path;
        const pathname = `${routePrefix}${previousPath || ''}`;

        store.dispatch(push(
            {
                search: search,
                pathname
            }
        ));
    }

    startOver() {
        if (this.props.location.pathname !== WELCOME_PAGE) {
            this.navigate(WELCOME_PAGE, null, true);
        }
    }

    reloadConfigWithServices() {
        const {context, customerToken} = this.resolveContextAndCustomer();
        store.dispatch(getConfigWithServices(context, customerToken));
    }

    resolveContextAndCustomer() {
        const context = getSafely(['match', 'params', 'context'], this.props, '');
        const customerToken = getSafely(['match', 'params', 'customer'], this.props, '');
        return {context, customerToken};
    }

    done(result) {
        if (result && result.paymentRequired) {
            store.dispatch(setSessionToken(result.resultToken, result.url));
            return this.navigate(PAYMENT_PATH);
        }

        try {
            const currentPath = '/' + valueOrDefault(window.location.pathname, '').split('/').pop();
            if (currentPath === SUCCESS_PATH) {
                return;
            }
        } catch (e) {

        }

        this.navigate(SUCCESS_PATH, null, true);
    }

    translateErrorOrFallback = (err, fallback) => {
        let translated = fallback;
        if (err && err.message) {
            translated = this.props.intl.formatMessage({id: err.message});
        }

        if (translated === fallback) {
            translated = this.props.intl.formatMessage({id: fallback});
        }

        return translated;
    }
}

const Routes = kPathMap.reduce((acc, curr) => Object.assign(acc, {
    [curr.path
        .replace('/', '')
        .replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        })
        ]: curr.path
}), {});

export {Routes};
